var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 55,
    viewBox: "0 0 66 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8475 1.12C39.6575 0.74 39.2675 0.5 38.8475 0.5H27.2774C26.8474 0.5 26.4674 0.74 26.2774 1.12L0.617411 52.54C0.447411 52.89 0.46746 53.3 0.66746 53.63C0.86746 53.96 1.23742 54.16 1.62742 54.16H64.5074C64.8974 54.16 65.2574 53.96 65.4674 53.63C65.6674 53.3 65.6874 52.89 65.5174 52.54L39.8574 1.12H39.8475ZM40.1374 51.92H3.43742L27.9775 2.75H30.4175L30.1474 5.77L31.2674 5.87L31.5474 2.75H34.5975L34.8774 5.87L35.9974 5.77L35.7275 2.75H38.1675L62.7074 51.92H40.1374Z",
    fill: "#C17A5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4914 23.9466L28.1143 28.1396L29.2298 28.24L29.6069 24.0469L28.4914 23.9466Z",
    fill: "#C17A5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9887 18.3577L28.6116 22.5508L29.7271 22.6511L30.1042 18.458L28.9887 18.3577Z",
    fill: "#C17A5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9941 7.15945L29.6169 11.3525L30.7324 11.4529L31.1096 7.25979L29.9941 7.15945Z",
    fill: "#C17A5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4969 12.7581L29.1198 16.9512L30.2352 17.0515L30.6124 12.8584L29.4969 12.7581Z",
    fill: "#C17A5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9941 29.5364L27.6169 33.7295L28.7324 33.8298L29.1096 29.6367L27.9941 29.5364Z",
    fill: "#C17A5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4804 46.3235L26.1033 50.5166L27.2188 50.6169L27.5959 46.4238L26.4804 46.3235Z",
    fill: "#C17A5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9886 40.7346L26.6115 44.9277L27.7269 45.0281L28.1041 40.835L26.9886 40.7346Z",
    fill: "#C17A5B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4968 35.135L27.1196 39.3281L28.2351 39.4285L28.6123 35.2354L27.4968 35.135Z",
    fill: "#C17A5B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6289 46.3186L38.5134 46.4189L38.8906 50.612L40.0061 50.5117L39.6289 46.3186Z",
    fill: "#C17A5B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1301 40.7258L38.0146 40.8262L38.3918 45.0192L39.5073 44.9189L39.1301 40.7258Z",
    fill: "#C17A5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.104 18.3567L35.9885 18.457L36.3657 22.6501L37.4812 22.5498L37.104 18.3567Z",
    fill: "#C17A5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6128 23.9485L36.4973 24.0488L36.8745 28.2419L37.99 28.1416L37.6128 23.9485Z",
    fill: "#C17A5B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6204 35.1243L37.5049 35.2246L37.8821 39.4177L38.9975 39.3173L38.6204 35.1243Z",
    fill: "#C17A5B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6044 12.7542L35.4889 12.8545L35.8661 17.0476L36.9816 16.9472L36.6044 12.7542Z",
    fill: "#C17A5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1056 7.17114L34.9901 7.27148L35.3673 11.4646L36.4828 11.3642L36.1056 7.17114Z",
    fill: "#C17A5B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0781 29.6047L36.9626 29.7051L37.3398 33.8982L38.4553 33.7978L38.0781 29.6047Z",
    fill: "#C17A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoads);
export default __webpack_public_path__ + "static/media/roads.162c44cf000677b040479fbadd405e16.svg";
export { ForwardRef as ReactComponent };